<div *ngIf="displayValue" class="ag-status-name-value ag-status-panel ag-status-panel-total-and-filtered-row-count">
    <span ref="eLabel">Rows</span>:&nbsp;
    <span ref="eValue" class="ag-status-name-value-value">{{displayValue}}</span>
</div>
